import React from 'react';
import classNames from 'classnames';
import Tag from '../Tag/Tag.component';
import { useTranslation } from 'react-i18next';
import { DealStage } from 'models/DealRoom';
import { checkIsUrgent, dateFormat } from 'utils';
import { ListingStage, ListingType } from 'models/Listing';
import {
  DEAL_STATUS_COLOR,
  DEAL_STATUS_LABEL,
  LISTING_STATUS_COLOR,
  LISTING_STATUS_LABEL,
} from 'data/dealStatus';
import { COLOR_VARIANT } from 'models/Colors';

import './TagsContainer.styles.scss';
import './TagsContainer.styles.responsive.scss';

type TagsContainerProps = {
  className?: string;
  isColleague: boolean;
  isOwnerOrSuperAdmin: boolean;
  dealStage: DealStage;
  listingStage: ListingStage;
  listingType: ListingType;
  date: Date;
  expiredDate: Date;
  withdrawnInterest?: boolean;
};

const TagsContainer: React.FC<TagsContainerProps> = (props) => {
  const {
    className,
    isColleague,
    isOwnerOrSuperAdmin,
    dealStage,
    listingStage,
    listingType,
    date,
    expiredDate,
    withdrawnInterest = false,
  } = props;

  const classes = classNames('tags-container', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {isColleague && (
        <Tag variant={COLOR_VARIANT.ORANGE_FULL} content={t('coOwner')} />
      )}

      {withdrawnInterest ? (
        <Tag variant={COLOR_VARIANT.RED_FULL} content={t('withdrawn')} />
      ) : (
        <>
          <Tag
            variant={DEAL_STATUS_COLOR[dealStage]}
            content={t(DEAL_STATUS_LABEL[dealStage])}
          />

          <Tag
            variant={LISTING_STATUS_COLOR[listingStage]}
            content={t(LISTING_STATUS_LABEL[listingStage])}
          />
        </>
      )}

      {isOwnerOrSuperAdmin && (
        <Tag
          variant={COLOR_VARIANT.GREY}
          content={`${t('created')} ${dateFormat(date)}`}
        />
      )}

      {isOwnerOrSuperAdmin && checkIsUrgent(listingType) && expiredDate && (
        <Tag
          variant={COLOR_VARIANT.RED}
          content={`${t('campaignExpires')} ${dateFormat(expiredDate)}`}
        />
      )}
    </div>
  );
};

export default TagsContainer;
